import { combineReducers } from 'redux';
import removeReducer from './form-delete';
import searchResultReducer from './search-result';
import formSearchReducer from './form-search';
import formManagerReducer from './form-manager';
import selectOptionsReducer from './select-options';

const servicesReducer = combineReducers({
  remove: removeReducer,
  searchResult: searchResultReducer,
  formSearch: formSearchReducer,
  formManager: formManagerReducer,
  selectOptions: selectOptionsReducer,
});

export default servicesReducer;
